import { InfoIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { useDevice } from '@contexts/device';

import Tooltip from '../Tooltip/next';
import { Label, TooltipText, Wrapper } from './styled';

const BankPosCard = ({
  promotionValueDetail,
  description,
}: {
  promotionValueDetail?: string;
  description?: string;
}) => {
  const { isDesktop } = useDevice();
  return (
    <>
      <Tooltip
        arrowColor='white'
        overlayInnerStyle={{
          borderRadius: '8px',
          width: '250px',
          lineHeight: 1.43,
          textAlign: 'center',
          backgroundColor: 'white',
        }}
        placement={isDesktop ? 'top' : 'topLeft'}
        title={<TooltipText>{description}</TooltipText>}
      >
        <Wrapper>
          <CustomIcon color='#004990' icon={InfoIcon} />
          <Label> Yapı Kredi’ye özel {promotionValueDetail} indirim</Label>
        </Wrapper>
      </Tooltip>
    </>
  );
};

export default BankPosCard;
